import React from 'react'

export const Hamburger = () => (
	<svg width="100%" height="100%" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
		<path d="M28.25 5H3.75C3.6125 5 3.5 5.1125 3.5 5.25V7.25C3.5 7.3875 3.6125 7.5 3.75 7.5H28.25C28.3875 7.5 28.5 7.3875 28.5 7.25V5.25C28.5 5.1125 28.3875 5 28.25 5ZM28.25 24.5H3.75C3.6125 24.5 3.5 24.6125 3.5 24.75V26.75C3.5 26.8875 3.6125 27 3.75 27H28.25C28.3875 27 28.5 26.8875 28.5 26.75V24.75C28.5 24.6125 28.3875 24.5 28.25 24.5ZM28.25 14.75H3.75C3.6125 14.75 3.5 14.8625 3.5 15V17C3.5 17.1375 3.6125 17.25 3.75 17.25H28.25C28.3875 17.25 28.5 17.1375 28.5 17V15C28.5 14.8625 28.3875 14.75 28.25 14.75Z" />
	</svg>
)
